import React, { Component } from 'react';
import './Main.css';

class Main extends Component {
    
    render() {
        return(
            <div className="main clearfix">
                { this.props.children }
            </div>
        );
    }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.js